module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/point_photowedding_01@3x-3ac605b8741cdad2bd244f0ee891d19a.webp";